import React from 'react';

function SvgIcNoRevision(props) {
  return (
    <svg viewBox="0 0 323.59 214.975" {...props}>
      <g data-name="Group 590" transform="translate(-66.442 -213.371)">
        <path
          data-name="Path 186"
          d="M94.658 289.803H79.393a13.014 13.014 0 01-12.951-12.989v-2.687a13.006 13.006 0 0112.951-12.951h15.228a12.982 12.982 0 0112.951 12.951v2.687a12.958 12.958 0 01-12.914 12.989z"
          fill="#5cc7da"
          opacity={0.1}
        />
        <path
          data-name="Path 187"
          d="M377.081 408.788h-15.228a12.982 12.982 0 01-12.951-12.951v-2.687a12.982 12.982 0 0112.951-12.951h15.228a12.982 12.982 0 0112.951 12.951v2.687a13.006 13.006 0 01-12.951 12.951z"
          fill="#5cc7da"
          opacity={0.1}
        />
        <path
          data-name="Path 188"
          d="M349.803 319.213h-32.177a94.079 94.079 0 00-152.128-58h-32.471a14.32 14.32 0 00-14.295 14.295 14.386 14.386 0 0011.906 14.108h23.14a15.642 15.642 0 0115.6 15.6v1.754a15.642 15.642 0 01-15.6 15.6h-46.28a14.32 14.32 0 00-14.295 14.297 14.32 14.32 0 0014.295 14.295h24.67a94.072 94.072 0 00150.635 57.1 13.933 13.933 0 003.77.523h36.43a14.32 14.32 0 0014.295-14.295 14.32 14.32 0 00-14.295-14.29h-21.5a15.308 15.308 0 01-15.265-15.265v-2.015a15.308 15.308 0 0115.265-15.267h34.524a13.147 13.147 0 012.463.224h11.234a14.32 14.32 0 0014.295-14.295 14.249 14.249 0 00-14.216-14.369z"
          fill="#5cc7da"
          opacity={0.1}
        />
        <circle
          data-name="Ellipse 149"
          cx={5.76}
          cy={5.76}
          r={5.76}
          transform="translate(142.321 215.871)"
          fill="none"
          stroke="#63d8f1"
          strokeMiterlimit={10}
          strokeWidth={5}
        />
        <circle
          data-name="Ellipse 150"
          cx={8.203}
          cy={8.203}
          r={8.203}
          transform="translate(282.126 224.249)"
          fill="none"
          stroke="#63d8f1"
          strokeMiterlimit={10}
          strokeWidth={5}
        />
        <circle
          data-name="Ellipse 151"
          cx={5.76}
          cy={5.76}
          r={5.76}
          transform="translate(319.695 299.867)"
          fill="none"
          stroke="#63d8f1"
          strokeMiterlimit={10}
          strokeWidth={5}
        />
        <path
          data-name="Path 189"
          d="M349.28 261.338h-8.9v-8.9a1.92 1.92 0 10-3.84 0v8.9h-8.9a1.92 1.92 0 100 3.84h8.9v8.9a1.92 1.92 0 103.84 0v-8.9h8.9a1.937 1.937 0 001.92-1.92 1.909 1.909 0 00-1.92-1.92z"
          fill="#63d8f1"
        />
        <path
          data-name="Path 190"
          d="M151.964 310.906h-8.9v-8.9a1.92 1.92 0 10-3.84 0v8.9h-8.946a1.92 1.92 0 100 3.84h8.9v8.9a1.92 1.92 0 103.84 0v-8.9h8.9a1.937 1.937 0 001.92-1.92 1.872 1.872 0 00-1.874-1.92z"
          fill="#63d8f1"
        />
        <path
          data-name="Path 191"
          d="M366.123 334.557l-4.887-4.887 4.887-4.887a1.481 1.481 0 10-2.095-2.094l-4.887 4.887-4.887-4.887a1.481 1.481 0 10-2.094 2.094l4.887 4.887-4.887 4.887a1.481 1.481 0 002.094 2.094l4.887-4.887 4.887 4.887a1.5 1.5 0 002.095 0 1.426 1.426 0 000-2.094z"
          fill="#63d8f1"
        />
        <g data-name="Group 230">
          <g data-name="Group 229">
            <path
              data-name="Path 195"
              d="M168.926 382.586h111.943c2.8 0 2.8-4.339 0-4.339H168.926c-2.8 0-2.8 4.339 0 4.339z"
              fill="#63d8f1"
            />
          </g>
        </g>
        <g data-name="Group 232">
          <g data-name="Group 231">
            <path
              data-name="Path 196"
              d="M295.331 382.586h7.953c2.8 0 2.8-4.339 0-4.339h-7.954c-2.8 0-2.8 4.339 0 4.339z"
              fill="#63d8f1"
            />
          </g>
        </g>
        <g data-name="Group 234">
          <g data-name="Group 233">
            <path
              data-name="Path 197"
              d="M130.455 382.586h24.973c2.8 0 2.8-4.339 0-4.339h-24.973c-2.8 0-2.8 4.339 0 4.339z"
              fill="#63d8f1"
            />
          </g>
        </g>
        <path
          data-name="Path 604"
          d="M366.123 334.556l-4.887-4.887 4.887-4.887a1.481 1.481 0 10-2.095-2.094l-4.887 4.887-4.887-4.887a1.481 1.481 0 10-2.094 2.094l4.887 4.887-4.887 4.887a1.481 1.481 0 002.094 2.094l4.887-4.887 4.887 4.887a1.5 1.5 0 002.095 0 1.426 1.426 0 000-2.094z"
          fill="#63d8f1"
        />
        <path
          data-name="Union 15"
          d="M245.076 367.725a18.711 18.711 0 1113.231 5.48 18.586 18.586 0 01-13.231-5.48zm-3.288-13.23a16.518 16.518 0 1016.519-16.519 16.537 16.537 0 00-16.519 16.519zm-1.1 12.663h-60.823v-82.682h23.557a7.8 7.8 0 117.644 9.36 1.56 1.56 0 110-3.119 4.68 4.68 0 10-4.394-6.241h2.833a1.56 1.56 0 110 3.12h-26.52v14.04h84.241v-14.04h-20.437a7.828 7.828 0 01-7.644 6.24 1.56 1.56 0 010-3.119 4.68 4.68 0 100-9.361 1.56 1.56 0 010-3.119 7.828 7.828 0 017.644 6.24h23.557v52a22.053 22.053 0 00-3.119-1.4v-30.321h-84.242v59.28h56.18a22.142 22.142 0 001.528 3.119zm23.5-5.7l-5.742-5.743-5.742 5.743a.737.737 0 01-1.042-1.042l5.742-5.742-5.742-5.743a.737.737 0 011.042-1.041l5.742 5.742 5.742-5.742a.737.737 0 011.042 1.041l-5.742 5.743 5.742 5.742a.737.737 0 01-1.042 1.042zm-54.268-22.265a13.572 13.572 0 011.75-7.355 14.325 14.325 0 001.248-11.736c-.529-1.793.4-2.693 2.221-2.254a8.617 8.617 0 014.232 2.222c.942.96 1.225.542 1.675-.4a16.463 16.463 0 016.973-7.563 6 6 0 011.876-.716c1.057-.169 1.894.381 1.694 1.463-1.039 5.649 1.851 10.035 4.5 14.516 1.608 2.724 3.413 5.322 4.1 8.528 1.924 9.031-5.294 18.227-14.482 18.323h-.179a15.382 15.382 0 01-15.612-15.028zm14.547-3.042a28.213 28.213 0 01-2.666 2.621 10.3 10.3 0 00-2.508 3.347 6.613 6.613 0 001.176 7.259 5.941 5.941 0 006.352 1.292 5.721 5.721 0 003.63-5.65c-.015-2.811-1.619-6.268-3.985-8.934-.4-.446-.7-.666-1-.666-.318 0-.62.246-1.001.731zm1.722-4.459c4.975 4.209 8.13 9.262 7.1 16.354a12.8 12.8 0 004.027-7.91c.46-3.842-1.209-6.951-3.155-10.035-2.219-3.517-4.41-7.061-5.424-11.176a11.966 11.966 0 00-.683-2.984 12.1 12.1 0 00-5.224 9c-.013.912.024 1.868-1.082 2.148-1.193.3-1.623-.6-2.048-1.476a7.914 7.914 0 00-3.01-3.669c-.023 6.118-.017 6.122-2.648 12.037a12.246 12.246 0 00-.811 7.031 9 9 0 002.232 5.03c.114-.147.229-.227.225-.3-.271-4.434 1.925-7.615 5.158-10.306a5.941 5.941 0 002.139-2.809c.349-1.157.865-1.741 1.558-1.741a2.751 2.751 0 011.641.806zm2.041-39.416a1.562 1.562 0 011.561-1.56 4.68 4.68 0 000-9.361 1.56 1.56 0 110-3.119 7.8 7.8 0 110 15.6 1.562 1.562 0 01-1.566-1.56zm-9.359 0a1.561 1.561 0 011.559-1.56 4.68 4.68 0 100-9.361 1.56 1.56 0 010-3.119 7.8 7.8 0 110 15.6 1.561 1.561 0 01-1.565-1.56z"
          fill="#104eb2"
        />
      </g>
    </svg>
  );
}

export default SvgIcNoRevision;
